import { Cell } from '@table-library/react-table-library/table';

export const COLUMNS = ({ defaultMethod, setAsDefault, t }) => [
    {
        label: t('payment_methods.table.card_holder_name'),
        key: 'billing_details',
        data: 'billing_details',
        Component: Cell,
        renderCell: ({ item }) => (
            <span>
                {item.billing_details.name}
                {defaultMethod === item.id && (
                    <span className="default-selected">{t('payment_methods.table.default')}</span>
                )}
            </span>
        ),
    },
    {
        label: t('payment_methods.table.card_type'),
        key: 'card',
        data: 'card',
        Component: Cell,
        renderCell: ({ item }) => item.card.brand,
    },
    {
        label: t('payment_methods.table.card_number'),
        key: 'card_number',
        data: 'card_number',
        Component: Cell,
        renderCell: ({ item }) => `**** **** **** ${item.card.last4}`,
    },
    {
        label: t('payment_methods.table.exp_date'),
        key: 'exp_date',
        data: 'exp_date',
        Component: Cell,
        renderCell: ({ item }) => `${item.card.exp_month}/${item.card.exp_year}`,
    },
    {
        label: t('payment_methods.table.action'),
        key: 'action',
        data: 'action',
        Component: Cell,
        renderCell: ({ item }) => {
            return defaultMethod !== item.id ? (
                <div className="payment-actions">
                    <button
                        className="set-default-btn"
                        onClick={() => setAsDefault(item.id)}
                        title={t('payment_methods.table.set_default')}
                    >
                        <span className="default-selected">
                            {t('payment_methods.table.set_default')}
                        </span>
                    </button>
                    <a
                        href={`/customers/detach/${item.id}/`}
                        className="delete-payment-method"
                        title={t('payment_methods.table.delete')}
                    >
                        <i className="icon-delete"></i>
                    </a>
                </div>
            ) : null;
        },
    },
];
